document.addEventListener("DOMContentLoaded", function () {

    const swatches = document.querySelectorAll(".color");

    const capName = document.getElementById("capName");
    const middleName = document.getElementById("middleName");
    const baseName = document.getElementById("baseName");

    const bottleCap = document.getElementById("BottleCap");
    const bottleMiddle = document.getElementById("BottleMiddle");
    const bottleBase = document.getElementById("BottleBase");

    const bottleCombination = document.getElementById("BottleCombination");

    // Hidden image inputs for cart
    const bottleCapImage = document.getElementById("BottleCapImage");
    const bottleMiddleImage = document.getElementById("BottleMiddleImage");
    const bottleBaseImage = document.getElementById("BottleBaseImage");


    function updateCombination() {

        const combo =
            capName.innerText +
            " • " +
            middleName.innerText +
            " • " +
            baseName.innerText;

        if (bottleCombination) {
            bottleCombination.value = combo;
        }

        console.log("Bottle Combination:", combo);

    }


    swatches.forEach(function (swatch) {

        swatch.addEventListener("click", function () {

            const part = this.dataset.part;
            const image = this.dataset.image;
            const name = this.dataset.name;

            // Remove active class from the same part
            document.querySelectorAll(
                '.color[data-part="' + part + '"]'
            ).forEach(function (item) {
                item.classList.remove("active");
            });

            // Add active class
            this.classList.add("active");


            // CAP
            if (part === "cap") {

                capName.innerText = name;

                if (image && bottleCap) {
                    bottleCap.src = image;
                }

                // Save selected cap image for cart
                if (image && bottleCapImage) {
                    bottleCapImage.value = image;
                }

            }


            // MIDDLE
            if (part === "middle") {

                middleName.innerText = name;

                if (image && bottleMiddle) {
                    bottleMiddle.src = image;
                }

                // Save selected middle image for cart
                if (image && bottleMiddleImage) {
                    bottleMiddleImage.value = image;
                }

            }


            // BASE
            if (part === "base") {

                baseName.innerText = name;

                if (image && bottleBase) {
                    bottleBase.src = image;
                }

                // Save selected base image for cart
                if (image && bottleBaseImage) {
                    bottleBaseImage.value = image;
                }

            }


            // Update combination text
            updateCombination();

        });

    });


    // Preload images
    swatches.forEach(function (swatch) {

        if (swatch.dataset.image) {

            const img = new Image();
            img.src = swatch.dataset.image;

        }

    });


    // Set initial combination
    updateCombination();

});